(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-title"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-nb-pdp-add]');
    if (!btn) return;
    var form = document.querySelector('product-form-component form[data-type="add-to-cart-form"]');
    if (form) {
      form.dispatchEvent(new SubmitEvent('submit', { bubbles: true, cancelable: true }));
    }
  });
  } catch(e) { console.error(e); }
})();

})();
